import { getDefaultDatePickerValue } from "../../../utils/dateFormat";
import { noInternetMsg, serverMsg } from "../../../config/messageconstant";

export const fetchListByBeatSelection = async ({
  data,
  searchBy,
  getOutletByBeatsAndAssignedStockHolder,
  getSalesExecutiveByBeatIds,
  showLoador,
  showNotification,
}) => {
  const result = {
    mainDataPatch: data,
  };

  if (data.flag != null && data.flag !== "") {
    result.searchBy = data.flag;
    result.formData = {
      flag: data.flag,
      beat: [],
      outletIds: [],
      salesPersonIds: [],
      fromdate: getDefaultDatePickerValue(),
      todate: getDefaultDatePickerValue(),
    };
  }

  if (!navigator.onLine) {
    showNotification({ msg: noInternetMsg, severity: "error" });
    return result;
  }

  const beatIds = data.beat;
  const hasBeatSelection =
    Array.isArray(beatIds) ? beatIds.length > 0 : beatIds && beatIds !== "";

  if (!hasBeatSelection) {
    return result;
  }

  const activeSearchBy =
    data.flag != null && data.flag !== "" ? data.flag : searchBy;

  showLoador({ loador: true });
  const apiResult =
    activeSearchBy == 0
      ? await getOutletByBeatsAndAssignedStockHolder({
          beatIds: { beatIds: data.beat },
        })
      : await getSalesExecutiveByBeatIds({ beatIds: data.beat.join() });
  showLoador({ loador: false });

  const { success, response } = apiResult ?? {};

  if (!success) {
    showNotification({ msg: serverMsg, severity: "error" });
    return result;
  }

  if (activeSearchBy == 0 && Array.isArray(response)) {
    result.dynamicMasterDataPatch = { outletDetail: response };
  } else if (activeSearchBy != 0 && Array.isArray(response)) {
    result.dynamicMasterDataPatch = { salesPersonDetail: response };
  }

  return result;
};
